"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/slicedToArray.js"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.function.name");

var _echarts = _interopRequireDefault(require("echarts"));

var _orderRate = require("@/api/cms/orderRate");

var _statCust = require("@/api/statCust");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'OrderRateChart',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      type: 'day',
      activeTab: 'rate',
      rateLoading: false,
      yoyLoading: false,
      pieLoading: false,
      rateChart: null,
      yoyChart: null,
      pieChart: null,
      pieDataFetched: false,
      pieTotal: 0,
      pieList: []
    };
  },
  computed: {
    visible: {
      get: function get() {
        return this.dialogVisible;
      },
      set: function set(val) {
        this.$emit('update:dialogVisible', val);
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.disposeCharts();
  },
  methods: {
    handleResize: function handleResize() {
      if (this.rateChart) this.rateChart.resize();
      if (this.yoyChart) this.yoyChart.resize();
      if (this.pieChart) this.pieChart.resize();
    },
    disposeCharts: function disposeCharts() {
      if (this.rateChart) {
        this.rateChart.dispose();
        this.rateChart = null;
      }

      if (this.yoyChart) {
        this.yoyChart.dispose();
        this.yoyChart = null;
      }

      if (this.pieChart) {
        this.pieChart.dispose();
        this.pieChart = null;
      }
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === 'pie' && !this.pieDataFetched) {
        this.fetchPieData();
      }
    },
    fetchAll: function fetchAll() {
      var _this = this;

      this.rateLoading = true;
      this.yoyLoading = true;
      Promise.all([(0, _orderRate.getOrderRate)({
        type: this.type
      }), (0, _orderRate.getOrderRateYoy)({
        type: this.type
      })]).then(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            rateRes = _ref2[0],
            yoyRes = _ref2[1];

        if (rateRes.code === 200) {
          _this.renderRateChart(rateRes.data);
        }

        if (yoyRes.code === 200) {
          _this.renderYoyChart(yoyRes.data);
        }
      }).catch(function () {
        _this.$message.error('获取数据失败');
      }).finally(function () {
        _this.rateLoading = false;
        _this.yoyLoading = false;
      });
    },
    fetchPieData: function fetchPieData() {
      var _this2 = this;

      this.pieLoading = true;
      (0, _statCust.getCustStatistics)({}).then(function (res) {
        _this2.pieDataFetched = true;

        _this2.renderPieChart(res);
      }).catch(function () {
        _this2.$message.error('获取统计数据失败');
      }).finally(function () {
        _this2.pieLoading = false;
      });
    },
    renderRateChart: function renderRateChart(data) {
      if (!this.$refs.rateChart) return;

      if (!this.rateChart) {
        this.rateChart = _echarts.default.init(this.$refs.rateChart);
      }

      var items = data || [];
      this.rateChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['客户数', '已下单客户数', '下单率(%)']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: items.map(function (i) {
            return i.dateKey;
          })
        },
        yAxis: [{
          type: 'value',
          name: '数量',
          minInterval: 1
        }, {
          type: 'value',
          name: '百分比(%)',
          max: 100,
          axisLabel: {
            formatter: '{value}%'
          }
        }],
        series: [{
          name: '客户数',
          type: 'line',
          data: items.map(function (i) {
            return i.customerCount;
          }),
          smooth: true,
          itemStyle: {
            color: '#409EFF'
          }
        }, {
          name: '已下单客户数',
          type: 'line',
          data: items.map(function (i) {
            return i.orderedCustomerCount;
          }),
          smooth: true,
          itemStyle: {
            color: '#67C23A'
          }
        }, {
          name: '下单率(%)',
          type: 'line',
          yAxisIndex: 1,
          data: items.map(function (i) {
            return i.orderRate;
          }),
          smooth: true,
          itemStyle: {
            color: '#E6A23C'
          }
        }]
      }, true);
    },
    renderYoyChart: function renderYoyChart(data) {
      if (!this.$refs.yoyChart) return;

      if (!this.yoyChart) {
        this.yoyChart = _echarts.default.init(this.$refs.yoyChart);
      }

      var items = data || [];
      this.yoyChart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['今年下单率(%)', '去年下单率(%)']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: items.map(function (i) {
            return i.dateKey;
          })
        },
        yAxis: {
          type: 'value',
          name: '百分比(%)',
          max: 100,
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: [{
          name: '今年下单率(%)',
          type: 'bar',
          data: items.map(function (i) {
            return i.currentOrderRate;
          }),
          itemStyle: {
            color: '#409EFF'
          }
        }, {
          name: '去年下单率(%)',
          type: 'bar',
          data: items.map(function (i) {
            return i.lastYearOrderRate;
          }),
          itemStyle: {
            color: '#909399'
          }
        }]
      }, true);
    },
    renderPieChart: function renderPieChart(data) {
      if (!this.$refs.pieChart) return;
      var stats = data || {};
      var colors = ['#67C23A', '#909399', '#E6A23C', '#52C41A', '#409EFF'];
      var rawData = [{
        name: '已下单',
        value: stats.ordered || 0,
        color: colors[0]
      }, {
        name: '未下单',
        value: stats.unordered || 0,
        color: colors[1]
      }, {
        name: '跟进中',
        value: stats.follow_up || 0,
        color: colors[2]
      }, {
        name: '已完成',
        value: stats.completed || 0,
        color: colors[3]
      }, {
        name: '售后',
        value: stats.after_sales || 0,
        color: colors[4]
      }];
      this.pieTotal = stats.total || 0;
      this.pieList = rawData;
      var chartData = rawData.filter(function (item) {
        return item.value > 0;
      }).map(function (item) {
        return {
          name: item.name,
          value: item.value,
          itemStyle: {
            color: item.color
          }
        };
      });

      if (!this.pieChart) {
        this.pieChart = _echarts.default.init(this.$refs.pieChart);
      }

      this.pieChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        series: [{
          type: 'pie',
          radius: ['45%', '75%'],
          center: ['50%', '55%'],
          label: {
            formatter: '{b}\n{d}%'
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          data: chartData
        }]
      }, true);
    }
  }
};
exports.default = _default;